import type { CreateImportJobRequest } from "@/lib/types/itsm-import";

/** Turns an import request into an export request. An export creates no
 *  tickets, so the desk targets go, and the options the API rejects on an
 *  export (they only shape created tickets) are left out rather than sent as
 *  false or null. */
export function toExportCsvRequest(
  request: CreateImportJobRequest,
): CreateImportJobRequest {
  const {
    target_desk_id: _targetDeskId,
    target_subdesk_id: _targetSubdeskId,
    create_tickets: _createTickets,
    dry_run: _dryRun,
    generate_insights: _generateInsights,
    include_audit_log: _includeAuditLog,
    include_custom_field_history: _includeCustomFieldHistory,
    sync_linked_tickets: _syncLinkedTickets,
    custom_field_mappings: _customFieldMappings,
    transform_code: _transformCode,
    ...exportRequest
  } = request;
  return { ...exportRequest, export_csv: true };
}

/** Starts the browser download of a presigned export URL. */
export function openDownload(url: string) {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
